/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const overviewFiltersInputDataDirectionSchema = z.enum(['asc', 'desc'])

export type OverviewFiltersInputDataDirectionSchema = z.infer<typeof overviewFiltersInputDataDirectionSchema>
